<div *ngIf="isLoggedIn">
    <app-navbar></app-navbar>
    <app-breadcrumb (newEvent)="toHome($event)"></app-breadcrumb>
    <router-outlet></router-outlet>
</div>

<app-footer class="mt-auto" *ngIf="isLoggedIn"></app-footer>
